// extracted by mini-css-extract-plugin
module.exports = {"titleSection":"TitleSection_titleSection__2VX2Q","title":"TitleSection_title__8hIgr"};